<template>
  <div class="promote flex flex-y">
    <div class="width-full text-0 relative">
      <img class="width-full"
       :src="require('@/assets/images/promote/register/bg.png') + `?timestamp=${new Date().valueOf()}`"
       alt="注册车主" />
      <button class="absolute text-14 text-white" @click="handleRule">活动规则</button>
    </div>
    <div class="padding-20" v-if="valid !== 2">
      <img v-if="valid === 0" src="~assets/images/promote/start.png" alt="" srcset="">
      <img v-if="valid === 1" src="~assets/images/promote/end.png" alt="" srcset="">
    </div>
    <div class="content text-12 text-white" v-else>
      <div class="text-16 margin-bottom-18">
        <input
          class="width-full height-full"
          v-model="params.mobile"
          type="mobile"
          maxlength="11"
          placeholder="请输入手机号，领现金"
        />
      </div>
      <div class="text-16 flex align-center">
        <div class="flex-1 height-full">
          <input
            class="width-full height-full"
            v-model="params.vert"
            type="number"
            maxlength="6"
            placeholder="请输入验证码"
          />
        </div>
        <div>
          <button
            :disabled="!!second || loading"
            v-bind:style="{ opacity: second ? '0.6' : '1' }"
            @click="sendMsg"
          >{{ second ? second + 's' : '获取验证码' }}</button>
        </div>
      </div>
      <button
        class="width-full text-0 flex"
        :disabled="loading"
        v-bind:style="{ opacity: loading ? '0.6' : '1' }"
        @click="onSubmit"
      ><img class="width-full" src="@/assets/images/promote/register/register-btn.png?time=123456" alt="提交" /></button>
    </div>
  </div>
</template>

<script>
import valid from '@/utils/valid'
import { joinActivity, getJoinActivityMobileCode, getActivityInfoById } from '@/api/modules/promote'
import validActivity from '@/utils/valid_activity'
export default {
  data () {
    return {
      loading: false,
      showAll: false,
      second: 0,
      params: {
        mobile: '',
        activityId: 212570000009,
        vert: ''
      },
      detail: {},
      valid: 2
    }
  },
  created () {
    this.getData()
  },
  methods: {
    toggleAll () {
      this.showAll = !this.showAll
    },
    handleRule () {
      this.$router.push('/agreement/detail/21165000000003')
    },
    getData () {
      getActivityInfoById(this.params.activityId).then((data) => {
        this.detail = { start: data.activityStartTime, end: data.activityEndTime }
        const valid = validActivity(data.activityStartTime, data.activityEndTime)
        this.valid = valid
      })
    },
    sendMsg () {
      const { mobile } = this.params
      if (!mobile) {
        this.$toast('请输入手机号')
        return
      }
      if (!valid.mobile.test(mobile)) {
        this.$toast('手机号格式不正确')
        return
      }

      if (!this.isValid()) return

      getJoinActivityMobileCode(this.params).then(() => {
        this.second = 60
        this.timer = setInterval(() => {
          this.second -= 1
          if (this.second === 0) {
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1e3)
        this.$toast('验证码发送成功，请注意查收')
      })
    },
    isValid () {
      const { start, end } = this.detail
      if (this.$moment() < this.$moment(start)) {
        this.$toast('该活动尚未开始~')
        return false
      } else if (this.$moment() > this.$moment(end)) {
        this.$toast('该活动已经结束~')
        return false
      }

      return true
    },
    onSubmit () {
      const { mobile, vert } = this.params

      if (!this.isValid()) return

      if (!mobile) {
        this.$toast('请输入手机号')
        return
      } else if (!valid.mobile.test(mobile)) {
        this.$toast('手机号格式不正确')
        return
      } else if (!vert.trim()) {
        this.$toast('请输入验证码')
        return
      }

      this.loading = true

      joinActivity({
        inviteeMobile: mobile,
        verifyCode: vert,
        activityId: this.params.activityId
      }).then(() => {
        this.$toast('领取成功')
        const _mobile = mobile.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')

        this.$router.push('/promote/driver/success?mobile=' + _mobile)
      }).catch(err => {
        if (err.message === '该用户已存在') {
          this.$dialog
            .confirm({
              message: '你已经是老用户了，前往APP领取更多福利～',
              confirmButtonColor: 'var(--primary)',
              closeOnClickOverlay: true
            })
            .then(() => {
              this.$router.push('/download')
            })
            .catch(() => {
              // on cancel
            })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.promote {
  min-height: 100vh;
  background-color: #FF5C1A;

  button,
  input {
    padding: 0px;
    margin: 0px;
    outline: none;
    border: none;
    background-color: transparent;
  }

  .text-0 {
    font-size: 0px;
  }

  .text-500 {
    font-weight: 500;
  }

  .text-17 {
    font-size: 17px;
  }

  .text-700 {
    font-weight: 700;
    font-size: 25px;
    font-family: DIN Alternate, DIN Alternate-Bold;
  }

  img + button.absolute {
    width: 85px;
    height: 30px;
    right: 0px;
    top: 8.395%;
    color: #FFE0D4;
    background-color: rgba(255, 255, 255, 0.22);
    border-radius: 15px 0px 0px 15px;
  }

  .content {
    padding: 10px 16px 40px;

    .bg-red {
      margin-top: 30px;
      border-radius: 10px;
      background-color: #FF410E;
    }

    .text-16 {
      height: 50px;
      border-radius: 25px;
      background-color: rgba(255, 255, 255, 0.92);

      &:not(.margin-bottom-18) {
        margin-bottom: 36px;
      }

      button {
        height: 35px;
        min-width: 113px;
        text-align: center;
        color: #FF5C1A;
        border-left: 1px solid rgba(255, 92, 26, 0.9);
      }
    }

    input {
      padding-left: 20px;
      color: #1F1F1F;
      font-weight: 500;

      &::-webkit-input-placeholder {
        font-weight: 400;
        color: #cccccc;
      }
    }
  }
}
</style>
